module.exports = __webpack_public_path__ + "img/home.16d2d2f9.svg";